<template>
  <div class="container">
    <div class="card mb-4">
      <div class="card-header d-flex align-items-center">
        <div class="ml-3">
          <h2 class="my-3">Add Room</h2>
        </div>
      </div>

      <div class="card-body">

        <div v-if="!loading && success !== ''" class="alert text-center alert-success">{{ success }}</div>

        <div v-if="!loading" class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="name">Name</label>
              <input v-model="name" class="form-control" type="text" id="name" name="name" placeholder="Type a name">
            </div>
          </div>
        </div>

        <div v-if="loading" class="text-center">
          <img src="@/assets/spinner.gif" alt="...">
        </div>

      </div>
      <div v-if="!loading" class="card-footer">
        <button :disabled="name === ''" @click.prevent="save"
                class="btn btn-primary"
                type="submit">Save
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import authHeader from "@/services/auth-header";

export default {
  data() {
    return {
      name: '',
      loading: false,
      success: '',
    }
  },
  methods: {
    async save() {
      this.loading = true;
      const data = {
        'name': this.name,
      }
      let email = this.$store.getters['auth/email'];
      await axios.post(`/api/v2/new-room/${email}`, data, {headers: authHeader()})
          .then((response) => {
            if (response.data === 'success') {
              this.success = 'Room added successfully';
              this.$store.dispatch('auth/getUserData');
            }
          });

      this.name = ''
      setTimeout(() => this.loading = false, 2000);
    }
  },
}
</script>
